/* eslint-disable jsx-a11y/accessible-emoji */
import { COMPETITION_PRIZE_HANDLES, MARKET } from '@nandosaus/constants';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '../grid';
import { Image } from '../image';
import { STATUS } from './constants';
import { useIsMinWidth } from '../../hooks/use-is-min-width';
import { useMarket } from '../../hooks/use-market';
import { Wheel } from './components/wheel';

const heartAnimationEnd = {
  rotate: [0, -10, 0, 10, 0],
  transition: {
    ease: 'easeInOut',
    repeat: 3,
    duration: 1,
  },
};

const Spinner = ({ controls }) => {
  const isMobile = !useIsMinWidth('md');
  const market = useMarket();
  const isAustralianMarket = market === MARKET.AUSTRALIA;

  return (
    <>
      <Box position="relative" mb="-16px" mx="auto" zIndex={1}>
        <motion.svg
          viewBox="0 0 46 82"
          width={isMobile ? '23' : '46'}
          height={isMobile ? '41' : '82'}
          animate={controls}
          variants={{
            [STATUS.START]: {
              rotate: [0, -10, 0, 10, 0, -10, 0, 10, 0, -10, 0, 10, 0, -10, 0, 10, 0],
              transition: {
                ease: 'easeInOut',
                duration: 1.4,
                delay: 1.6,
              },
            },
            [STATUS.SPIN]: {
              rotate: [0, -10, 0, 10, 0],
              transition: {
                ease: 'easeInOut',
                repeat: Infinity,
                duration: 0.3,
              },
            },
            [COMPETITION_PRIZE_HANDLES.DRINK]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.GIFT_CARD]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.GRAND_PRIZE]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.QUARTER_CHICKEN_MEAL]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.SIDE]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.CHIP_DIP_VARIETIES]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.CHEESY_GARLIC_MINI_PITA]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.CHOCOLATE_MOUSSE]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.LARGE_SIDE]: heartAnimationEnd,
            [COMPETITION_PRIZE_HANDLES.NAUGHTY_NATA]: heartAnimationEnd,
            [STATUS.LOSE]: heartAnimationEnd,
          }}
          style={{ originX: 'top', originY: '50%' }}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.96 27.116s2.252-7.082 3.176-9.383c1.26-3.191 4.341-9.615 10.799-8.52.643.105 7.904.406 3.855 15.725-2.269 7.816-10.845 23.19-17.152 34.502a27034.36 27034.36 0 0 1-6.326 11.353L5.281 25.604s-5.654-19.959 6.795-21.6c2.15.026 11.551-.682 9.883 23.112Z"
            fill="#FE2050"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.28 25.604s-5.653-19.959 6.796-21.6h.21c1.966.004 7.88.016 9.472 11.424.045.324.087.656.125.998l.002.023c.315 2.852.376 6.357.074 10.667 0 0 2.253-7.082 3.177-9.383.197-.497.438-1.074.729-1.688 1.575-3.324 4.619-7.756 10.07-6.833l.1.014c1.076.137 7.65.972 3.755 15.712-2.265 7.802-10.814 23.134-17.118 34.44l-.034.062-3.462 6.215-2.864 5.138L5.281 25.604Zm20.852 35.784-4.53 8.13-1.796 3.222-3.494-1.947 3.494 1.948-4.963 8.9L1.41 26.611l-.003-.011a32.704 32.704 0 0 1-.236-.933 44.639 44.639 0 0 1-.517-2.51C.291 21.108-.07 18.273.012 15.31c.08-2.904.591-6.32 2.291-9.247C4.123 2.929 7.166.616 11.553.038L11.838 0l.288.004h.204C13.651 0 17.993-.013 21.48 4.037c1.346 1.564 2.448 3.594 3.244 6.203.29-.373.6-.74.93-1.096 2.381-2.564 6.034-4.7 10.927-3.88-.127-.022 1.061.095 2.278.58a8.923 8.923 0 0 1 4.049 3.247c2.402 3.463 2.872 8.835.748 16.87l-.012.046-.013.046c-1.257 4.329-4.144 10.445-7.349 16.659-3.234 6.27-6.965 12.961-10.102 18.588l-.048.086-.001.002Z"
            fill="#000"
          />
        </motion.svg>
      </Box>
      <WheelContainer position="relative" left="50%" width="550px">
        <Wheel controls={controls} />
        <Box
          display="flex"
          top="50%"
          left="50%"
          mt="-50px"
          ml="-50px"
          justifyContent="center"
          alignItems="center"
          width="100px"
          height="100px"
          position="absolute"
          backgroundColor="white"
          boxShadow="0 0 10px rgba(16, 18, 18, 0.25)"
          borderRadius="50px"
        >
          {isAustralianMarket ? (
            <Image alt="Coca-Cola logo" width="71" height="24" src="/static/images/brand/coca-cola-logo.png" />
          ) : (
            <Image alt="Rooster logo" width="63" height="83" src="/static/images/spin-to-win/rooster-logo.png" />
          )}
        </Box>
      </WheelContainer>
    </>
  );
};

const WheelContainer = styled(Box)`
  transform: translate(-50%);
`;

Spinner.propTypes = {
  controls: PropTypes.shape({}).isRequired,
};

export { Spinner };
